/**
 * @module features/devices/api/useDeviceStats
 * @description Query hooks for fleet metrics and the device-type catalog.
 */
import { useQuery } from "@tanstack/react-query";
import { deviceKeys, getDeviceStats, getDeviceTypes } from "./devices-api";

export function useDeviceStats() {
  return useQuery({
    queryKey: deviceKeys.stats,
    queryFn: getDeviceStats,
    refetchInterval: 60_000, // aligned with the server cache TTL
  });
}

export function useDeviceTypes() {
  return useQuery({
    queryKey: deviceKeys.types,
    queryFn: getDeviceTypes,
    staleTime: 10 * 60_000, // catalog rarely changes
  });
}
